import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Img } from "./shared/img";
import { useTranslationsById } from "../hooks/use-translations-by-id";
import { useId } from "../hooks/use-id";

export const DemoRequest = () => {
	const textos = useTranslationsById({ mainSectionName: "demo_request" });
	const history = useHistory();
	const [email, setEmail] = useState("");
	const inputDemoId = useId("inputCorreoDemo");

	const handleSubmit = (e) => {
		if (e) {
			e.preventDefault();
		}
		history.push({
			pathname: "/contacto/demo",
			search: `?email=${encodeURIComponent(email)}`,
		});
	};

	return (
		<div className="p-3 py-4 red--bg onred--color">
			<div className="container">
				<div className="d-md-flex justify-content-center">
					<div
						className="col-12 col-md-7 col-lg d-flex d-md-block flex-column justify-content-center align-items-center"
						style={{ maxWidth: 600 }}
					>
						<h2
							className="text-left secondary-font w-100"
							style={{ fontSize: "1.3em" }}
						>
							{textos.getText({
								id: "demo_request.title",
								defaultText: "Agenda tu demo ahora",
							})}
						</h2>
						<form
							className="m-0 p-0 my-2 row align-items-center"
							onSubmit={(e) => handleSubmit(e)}
						>
							<label htmlFor={inputDemoId} className="sr-only">
								{textos.getText({
									id: "demo_request.input.placeholder",
									defaultText: "Correo electrónico",
								})}
							</label>
							<input
								className="form-control col-12 col-md focusable-secondary"
								onChange={(e) => setEmail(e?.target?.value)}
								placeholder={textos.getText({
									id: "demo_request.input.placeholder",
									defaultText: "Correo electrónico",
								})}
								type="email"
								required
								id={inputDemoId}
							/>
							<div className="d-flex d-md-block col m-0 p-0 justify-content-end">
								<button className="btn btn-primary p-2 px-3 mx-0 my-3 m-md-3 focusable-primary">
									{textos.getText({
										id: "demo_request.button.submit",
										defaultText: "Agendar",
									})}
								</button>
							</div>
							<p
								className="py-3 text-left font-weight-light"
								style={{ fontSize: "0.9em" }}
							>
								{textos.getText({
									id: "terminos_condiciones_politica1",
									defaultText: "Al ingresar tus datos estás aceptando",
								})}{" "}
								<Link
									className="focusable-secondary onred--color font-weight-bold"
									to="/terminos-y-condiciones"
								>
									{textos.getText({
										id: "terminos_condiciones_politica2",
										defaultText: "Términos y condiciones",
									})}
								</Link>{" "}
								{textos.getText({
									id: "terminos_condiciones_politica3",
									defaultText: "y",
								})}{" "}
								<Link
									className="focusable-secondary onred--color font-weight-bold"
									to="/politica-de-privacidad"
								>
									{textos.getText({
										id: "terminos_condiciones_politica4",
										defaultText: "Política de privacidad",
									})}
								</Link>
							</p>
						</form>
					</div>
					<div className="col d-flex">
						<Img
							className="img-fluid accesible-image"
							src="/img/demo/demo-running.png"
							alt="newsletter-speaker"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
